export function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) return true;

  if (a === null || b === null) return false;

  if (typeof a !== typeof b) return false;

  if (typeof a === 'object' && typeof b === 'object') {
    if (a instanceof Date && b instanceof Date) {
      return a.getTime() === b.getTime();
    }

    if (Array.isArray(a) && Array.isArray(b)) {
      return arrayDeepEqual(a, b);
    }

    if (a instanceof Map && b instanceof Map) {
      return mapDeepEqual(a, b);
    }

    return objectDeepEqual(a as Record<string, unknown>, b as Record<string, unknown>);
  }

  return false;
}

export function arrayDeepEqual<T>(a: T[], b: T[]): boolean {
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; i++) {
    if (!deepEqual(a[i], b[i])) return false;
  }

  return true;
}

export function mapDeepEqual<K, V>(a: Map<K, V>, b: Map<K, V>): boolean {
  if (a.size !== b.size) return false;

  for (const [key, valueA] of a.entries()) {
    const valueB = b.get(key);
    if (!valueB) return false;

    if (!deepEqual(valueA, valueB)) return false;
  }

  return true;
}

export function objectDeepEqual<T extends Record<string, unknown>>(a: T, b: T): boolean {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  return keysA.every((key) => {
    if (!Object.prototype.hasOwnProperty.call(b, key)) return false;

    return deepEqual(a[key], b[key]);
  });
}
